import { API_URL } from '../../config';
import { CALL_API } from '../../middlewares/apiMiddleware';
import { MAIN_GET_COMMON_DATA, PENDING, FULFILLED, REJECTED } from '../../globals';


export function getCommonDataRequest(){
  return {
    type: `${MAIN_GET_COMMON_DATA}_${PENDING}`,
    payload: {
      refresh: true,
    }
  };
}

export function getCommonDataSuccess(response){
  return {
    type: `${MAIN_GET_COMMON_DATA}_${FULFILLED}`,
    payload: {
      data: response.data,
      status: response.status,
    }
  };
}

export function getCommonDataFailure(response){
  return {
    type: `${MAIN_GET_COMMON_DATA}_${REJECTED}`,
    payload: {
      errorMessage: response,
    }
  };
}


export const getCommonData = () => ({
  [CALL_API]: {
    actions: [getCommonDataRequest, getCommonDataSuccess, getCommonDataFailure],
    url: `${API_URL}/web/order/settings`,
  },
});
